__turbopack_context__.v({
  "box": "common-input-module-scss-module__vuQAza__box",
  "header": "common-input-module-scss-module__vuQAza__header",
  "header__error": "common-input-module-scss-module__vuQAza__header__error",
  "header__error_visible": "common-input-module-scss-module__vuQAza__header__error_visible",
  "input": "common-input-module-scss-module__vuQAza__input",
  "input_error": "common-input-module-scss-module__vuQAza__input_error",
  "input_outline": "common-input-module-scss-module__vuQAza__input_outline",
  "input_primary": "common-input-module-scss-module__vuQAza__input_primary",
  "label": "common-input-module-scss-module__vuQAza__label",
  "label_error": "common-input-module-scss-module__vuQAza__label_error",
  "label_primary": "common-input-module-scss-module__vuQAza__label_primary",
  "wrapper": "common-input-module-scss-module__vuQAza__wrapper",
  "wrapper_error": "common-input-module-scss-module__vuQAza__wrapper_error",
  "wrapper_outline": "common-input-module-scss-module__vuQAza__wrapper_outline",
  "wrapper_primary": "common-input-module-scss-module__vuQAza__wrapper_primary",
});
